import * as React from 'react';
export const IOSvg = React.forwardRef(function IOSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M5.46 3.091H16v1.091H5.46zm0 2.182H16v1.091H5.46zM0 7.455h16v1.091H0zm0 2.181h16v1.091H0zm0 2.182h16v1.091H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M0 4a2 2 0 0 1 2-2h6v6H0V4Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'M1.346 5.964H0V4.036h3v-.107L.748 2.44c.267-.213.59-.36.943-.415L3 2.89V2h2v2.036h.046L8 2.08v1.04l-1.383.915H8v1.928H5v.083l2.934 1.941h-1.57L5 7.086V8H3V5.964h-.082L0 7.894v-1.04l1.346-.89Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      fillRule: 'evenodd',
      d: 'M.747 2.44a2.008 2.008 0 0 0-.544.68l1.384.916H3V3.93L.747 2.441ZM5 6.07v-.106h1.413L8 7.014V8h-.08L5 6.07Zm-2-.106v.987L1.414 8H0v-.104l2.92-1.932H3Zm2-1.928h.08L8 2.104V2H6.586L5 3.049v.987Zm-.556 1.39H8v-.853H4.444V2h-.888v2.573H0v.854h3.556V8h.888V5.427Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      fillOpacity: 0.1,
      fillRule: 'evenodd',
      d: 'M2 14h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2ZM14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12Z',
      clipRule: 'evenodd',
    }),
  );
});
IOSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var IO = {
  category: 'flag',
  colorable: false,
  name: 'IO',
  svg: IOSvg,
};
